import { render, staticRenderFns } from "./LocationNodeBasic.vue?vue&type=template&id=30923dda&"
import script from "./LocationNodeBasic.vue?vue&type=script&lang=js&"
export * from "./LocationNodeBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports